import AppRoutes from "./routes/AppRoutes";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <>
      <AppRoutes />
      <Toaster
        richColors
        position="top-right"
        theme="light"
        className="toaster-custom"
      />
    </>
  );
}

export default App;
